<template>
  <div>
    <div class="w-full grid grid-cols-2 gap-4 items-start bg-white">
      <div class="p-8 shadow rounded-12px border">
        <h2 class="text-2xl mt-6 font-bold text-black">
          Got new project requirements?
        </h2>
        <p class="text-md font-medium text-gray mt-2">
          Get them BR<span class="col-ffc1">AI</span>NED! Create a new project
          scope and get instant recommendations for user roles and pages
        </p>

        <div class="relative my-4 w-full">
          <el-input
            placeholder="Enter"
            v-model="requirement"
            :rows="8"
            type="textarea"
            class="w-full"
          />
          <!-- <div class="absolute top-0 right-0 p-3">
                <feather-icon
                  icon="MicIcon"
                  class="text-primary"
                  svgClasses="w-5 h-5"
                />
              </div> -->
        </div>

        <div class="flex w-full justify-end">
          <vs-button
            @click="gatherRequirements"
            variant="primary"
            class="font-semibold rounded-full fsize14 py-4 px-12 sm-fsize14"
          >
            Process
          </vs-button>
        </div>
      </div>
      <div class="p-8 shadow rounded-12px border relative">
        <h2 class="text-2xl mt-4 font-bold text-black">
          Here's a quick Starting Point
        </h2>
        <p class="text-md font-medium text-gray mt-2">
          Get them BR<span class="col-ffc1">AI</span>NED! Here's a list of all
          User Roles & Pages auto recommended by our AI to give you an initial
          perspective of scope requirements.
        </p>
        <div class="my-8">
          <h2 class="text-2xl font-bold text-black">User Roles</h2>
          <div class="mt-4 flex gap-2 items-center flex-wrap">
            <ul v-for="item in RolesData" :key="item.id">
              <li>
                <p
                  :class="
                    newScopeRoles.includes(item.role)
                      ? 'fsize12 text-white rounded-full px-6 py-2 text-warning light-chipswarning cursor-pointer'
                      : 'fsize12 text-white rounded-full px-6 py-2 bg-9c cursor-pointer'
                  "
                  @click="addToScopeRole(item.role)"
                >
                  {{ item.role }}
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="my-8">
          <h2 class="text-2xl font-bold text-black">Pages</h2>
          <div class="mt-4 flex gap-2 items-center flex-wrap">
            <ul v-for="item in PagesData" :key="item.id">
              <li>
                <p
                  :class="
                    newScopePages.includes(item.page)
                      ? 'fsize12 text-dark rounded-lg px-8 py-2 text-warning light-chipswarning cursor-pointer'
                      : 'fsize12 text-dark rounded-lg px-8 py-2 bg-ebs cursor-pointer'
                  "
                  @click="addToScopePage(item.page)"
                >
                  {{ item.page }}
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="flex w-full justify-end">
          <vs-button
            variant="primary"
            class="font-semibold rounded-full fsize14 py-4 my-3 px-8 sm-fsize14"
            @click="saveRequirement"
          >
            Create New Scope
          </vs-button>
        </div>
        <div
          class="absolute top-0 h-full w-full filter-bzindex right-0 left-0 flex items-center justify-center"
          v-if="showloader"
        >
          <div class="loaderdd"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      requirement: "",
      RolesData: [],
      PagesData: [],
      showloader: false,
      displayRequirement: "",
      newScopeRoles: [],
      newScopePages: [],
    };
  },
  props: {
    isshowscope: {
      type: Boolean,
      required: true,
    },
    tabForReq: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleback(name) {
      this.$router.push({ name: name });
    },
    async gatherRequirements() {
      this.displayRequirement = this.requirement;
      const chatpayload = {
        ROLES:
          "site roles for the following user requirement in the single array of format only and every object has role as its first key " +
          this.requirement,
        PAGES:
          "site pages for the following user requirement in the single array of 10-20 objects format only and every object has page as its first key " +
          this.requirement,
      };
      // this.requirement = "";

      this.showloader = true;
      const dataRoles = await axios.post(
        "https://api-builder-api.aiab.in/api/v1/Recommendation_v1",
        { string: chatpayload.ROLES }
      );
      this.RolesData = dataRoles.data;
      const dataPages = await axios.post(
        "https://api-builder-api.aiab.in/api/v1/Recommendation_v1",
        { string: chatpayload.PAGES }
      );

      this.PagesData = dataPages.data;
      this.showloader = false;
    },
    async saveRequirement() {
      const pages = this.PagesData.map((x) => {
        return { TYPES: "PAGES", text: x.page };
      });
      const roles = this.RolesData.map((x) => {
        return { TYPES: "ROLES", text: x.role };
      });
      const recommendData = [...roles, ...pages];
      const savePayload = {
        projectName: this.selectedProject.projectName,
        _id: this.selectedSprint._id,
        user: this.selectedProject.projectName,
        requirement: this.requirement,
        RecommendData: recommendData,
      };
      this.$store.dispatch("builder/saveRequirements", savePayload);
      this.$swal({
        title: "Success!",
        text: `Your requirement is Successfully sent`,
        icon: "success",

        buttons: false,
      });

      // this.$emit("newScopeReq", {
      //   newScopeRoles,
      //   newScopePages,
      // });
      await this.addLogsData();
      this.displayRequirement = "";
      this.newScopeRoles = [];
      this.newScopePages = [];
      this.RolesData = [];
      this.PagesData = [];
      this.requirement = "";
      this.$emit("closePopupFunc", {
        isisshowscope: false,
      });
    },
    addToScopeRole(value) {
      console.log(value);
      this.newScopeRoles.push(value);
    },
    addToScopePage(value) {
      console.log(value);
      this.newScopePages.push(value);
    },
    async addLogsData() {
      if (this.newScopePages.length) {
        for (let i in this.newScopePages) {
          let payload = {
            tasklistID: this.selectedSprint._id,
            projectName: this.selectedProject.projectName,
            logDraftName: this.tabForReq._id,
            source: "Admin",
            action: "Add",
            name: this.newScopePages[i],
            type: "Page",
            pageSource: "Website",
          };
          const { data } = await this.$store.dispatch(
            "logsForPagesRoles/addLogsDetails",
            payload
          );
        }
      }
      if (this.newScopeRoles.length) {
        for (let i in this.newScopeRoles) {
          let payload = {
            tasklistID: this.selectedSprint._id,
            projectName: this.selectedProject.projectName,
            source: "Admin",
            logDraftName: this.tabForReq._id,
            action: "Add",
            name: this.newScopeRoles[i],
            type: "Role",
          };
          const { data } = await this.$store.dispatch(
            "logsForPagesRoles/addLogsDetails",
            payload
          );
        }
      }
    },
  },
  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("design", ["selectedSprint"]),
  },
};
</script>
